import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import icon from 'flarum/common/helpers/icon';
import humanTime from 'flarum/common/helpers/humanTime';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';

export default class DiscussionCreatedNotification extends Notification {
  icon() {
    return 'fa-light fa-comment-dots';
  }

  // 覆盖 view 方法，不显示 avatar
  view(vnode) {
    const notification = this.attrs.notification;
    const href = this.href?.() ?? '';

    return (
      <Link
        className={classList('Notification', `Notification--${notification.contentType()}`, [!notification.isRead() && 'unread'])}
        href={href}
        external={href.includes('://')}
        onclick={this.markAsRead.bind(this)}
      >
        {/* 不显示 avatar */}
        {icon(this.icon?.(), { className: 'Notification-icon' })}
        <span className="Notification-title">
          <span className="Notification-content">{this.content?.()}</span>
          <span className="Notification-title-spring" />
          {humanTime(notification.createdAt())}
        </span>
        {!notification.isRead() && (
          <Button
            className="Notification-action Button Button--link"
            icon="fas fa-check"
            title={app.translator.trans('core.forum.notifications.mark_as_read_tooltip')}
            onclick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              this.markAsRead();
            }}
          />
        )}
        <div className="Notification-excerpt">{this.excerpt?.()}</div>
      </Link>
    );
  }

  href() {
    
    // 从 content 中获取 discussion_id
    const content = this.attrs.notification.content();
    
    if (content && content.discussion_id) {
      
      // 首先尝试从 store 中获取 discussion
      const discussion = app.store.getById('discussions', content.discussion_id);
      
      if (discussion && typeof discussion.slug === 'function') {
        try {
          const href = app.route.discussion(discussion);
          return href;
        } catch (e) {
          console.error('[DiscussionCreatedNotification] ❌ 生成 href 时出错:', e);
        }
      }
      
      // 如果 discussion 不在 store 中，直接使用 discussion_id 和 discussion_slug 构建 URL
      // Flarum 的讨论 URL 格式是 /d/{id}-{slug}
      const discussionId = content.discussion_id;
      const discussionSlug = content.discussion_slug;
      
      // 构建 URL
      let href = `/d/${discussionId}`;
      if (discussionSlug) {
        href = `/d/${discussionId}-${discussionSlug}`;
      }
      
      return href;
    } else {
      console.warn('[DiscussionCreatedNotification] ⚠️ content 或 discussion_id 不存在');
    }
    
    return '';
  }

  content() {
    const notification = this.attrs.notification;
    const fromUser = notification.fromUser();
    const username = fromUser ? fromUser.displayName() : '';
    const content = notification.content();
    const groupName = content?.group_name || '';
    const discussionTitle = content?.discussion_title || '';
    
    return app.translator.trans('tf-cns-notifications.forum.notifications.discussion_created_text', {
      username: username,
      group: groupName,
      title: discussionTitle
    });
  }

  excerpt() {
    return null;
  }
}

